import { useSelector } from 'react-redux';
import { getFormatDataByTheatreID, isLoadingListItemFormats } from '../selectors';

export const useListItemFormatData = (id) => {
  return [useSelector(getFormatDataByTheatreID(id)), useSelector(isLoadingListItemFormats(id))];
};
